export default {
  previous: {
    id: 'back-office-seller.listings.pagination.previous',
    defaultMessage: 'Previous',
  },
  next: {
    id: 'back-office-seller.listings.pagination.next',
    defaultMessage: 'Next',
  },
}
